import state from "@/store/state";
const extractArray = (arr)=>{
    return arr.map(x=>{
        if(arr.children?.length > 0){
            return extractArray(x.children)
        }else{
            return x
        }
    })

}
const Acl = (module, action)=>{
    let menus = state.menus.map(x => {
        if(x.children?.length > 0){
            return extractArray(x.children)
        }else{
            return x
        }
    }).flat(Infinity)

    let item = menus.find(x=>x.module === module)

    if(!item.action.includes(action)){
        return false
    }
    return true
}
export default Acl;